import { useState } from "react";
import axios from "axios";

const API_URL = process.env.REACT_APP_BACKEND_URL;

const ShopifyIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <path d="M15.337 23.979l7.216-1.561s-2.604-17.613-2.625-17.73c-.018-.116-.114-.192-.211-.192s-1.929-.136-1.929-.136-1.275-1.274-1.439-1.411c-.045-.037-.075-.057-.121-.074l-.914 21.104h.023zM11.71 11.305s-.81-.424-1.774-.424c-1.447 0-1.504.906-1.504 1.141 0 1.232 3.24 1.715 3.24 4.629 0 2.295-1.44 3.76-3.406 3.76-2.354 0-3.54-1.465-3.54-1.465l.646-2.086s1.245 1.066 2.28 1.066c.675 0 .975-.545.975-.932 0-1.619-2.654-1.694-2.654-4.359-.034-2.237 1.571-4.416 4.827-4.416 1.257 0 1.875.361 1.875.361l-.945 2.715-.02.01zM11.17.83c.136 0 .271.038.405.135-.984.465-2.064 1.639-2.508 3.992-.656.213-1.293.405-1.889.578C7.697 3.75 8.951.84 11.17.84V.83zm1.235 2.949v.135c-.754.232-1.583.484-2.394.736.466-1.777 1.333-2.645 2.085-2.971.193.501.309 1.176.309 2.1zm.539-2.234c.694.074 1.141.867 1.429 1.755-.349.114-.735.231-1.158.366v-.252c0-.752-.096-1.371-.271-1.871v.002zm2.992 1.289c-.02 0-.06.021-.078.021s-.289.075-.714.21c-.423-1.233-1.176-2.37-2.508-2.37h-.115C12.135.209 11.669 0 11.265 0 8.159 0 6.675 3.877 6.21 5.846c-1.194.365-2.063.636-2.16.674-.675.213-.694.232-.772.87-.075.462-1.83 14.063-1.83 14.063L15.009 24l.927-21.166z"/>
  </svg>
);

const WooCommerceIcon = () => (
  <svg width="28" height="28" viewBox="0 0 24 24" fill="currentColor">
    <path d="M.754 9.58a.754.754 0 00-.754.758v2.525c0 .42.339.758.758.758h3.135l1.431.799-.326-.799h2.373a.757.757 0 00.758-.758v-2.525a.757.757 0 00-.758-.758H.754zm2.709.445h.03c.065.001.124.023.179.067a.26.26 0 01.103.19.29.29 0 01-.033.16c-.13.239-.236.64-.322 1.199-.083.541-.114.965-.094 1.267a.392.392 0 01-.039.219.213.213 0 01-.176.12c-.086.006-.177-.034-.263-.124-.31-.316-.555-.788-.735-1.416-.216.425-.375.744-.478.957-.196.376-.363.568-.502.578-.09.007-.166-.069-.233-.228-.17-.436-.352-1.277-.548-2.524a.297.297 0 01.054-.222c.047-.064.116-.095.21-.102.169-.013.265.065.288.238.103.695.217 1.284.336 1.766l.727-1.387c.066-.126.15-.192.25-.199.146-.01.237.083.273.28.083.441.188.817.315 1.136.086-.844.233-1.453.44-1.828a.255.255 0 01.218-.147z"/>
  </svg>
);

const BigCommerceIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <path d="M12.645 13.663h3.027c.861 0 1.406-.474 1.406-1.235 0-.717-.545-1.234-1.406-1.234h-3.027c-.1 0-.187.086-.187.172v2.125c.015.1.086.172.187.172zm0 4.896h3.128c.961 0 1.535-.488 1.535-1.35 0-.746-.545-1.35-1.535-1.35h-3.128c-.1 0-.187.087-.187.173v2.34c.015.115.086.187.187.187zM23.72.053l-8.953 8.93h1.464c2.281 0 3.63 1.435 3.63 3 0 1.235-.832 2.14-1.722 2.541-.143.058-.143.259.014.316 1.033.402 1.765 1.48 1.765 2.742 0 1.78-1.19 3.202-3.5 3.202h-6.342c-.1 0-.187-.086-.187-.172V13.85L.062 23.64c-.13.13-.043.359.143.359h23.631a.16.16 0 0 0 .158-.158V.182c.043-.158-.158-.244-.273-.13z"/>
  </svg>
);

const WixIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <path d="m0 7.354 2.113 9.292h.801a1.54 1.54 0 0 0 1.506-1.218l1.351-6.34a.171.171 0 0 1 .167-.137c.08 0 .15.058.167.137l1.352 6.34a1.54 1.54 0 0 0 1.506 1.218h.805l2.113-9.292h-.565c-.62 0-1.159.43-1.296 1.035l-1.26 5.545-1.106-5.176a1.76 1.76 0 0 0-2.19-1.324c-.639.176-1.113.716-1.251 1.365l-1.094 5.127-1.26-5.537A1.33 1.33 0 0 0 .563 7.354H0zm13.992 0a.951.951 0 0 0-.951.95v8.342h.635a.952.952 0 0 0 .951-.95V7.353h-.635zm1.778 0 3.158 4.66-3.14 4.632h1.325c.368 0 .712-.181.918-.486l1.756-2.59a.12.12 0 0 1 .197 0l1.754 2.59c.206.305.55.486.918.486h1.326l-3.14-4.632L24 7.354h-1.326c-.368 0-.712.181-.918.486l-1.772 2.617a.12.12 0 0 1-.197 0L18.014 7.84a1.108 1.108 0 0 0-.918-.486H15.77z"/>
  </svg>
);

const SquareIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <path d="M4.01 0A4.01 4.01 0 000 4.01v15.98c0 2.21 1.8 4 4.01 4.01h15.98C22.2 24 24 22.2 24 19.99V4A4.01 4.01 0 0019.99 0H4zm1.62 4.36h12.74c.7 0 1.26.57 1.26 1.27v12.74c0 .7-.56 1.27-1.26 1.27H5.63c-.7 0-1.26-.57-1.26-1.27V5.63a1.27 1.27 0 011.26-1.27zm3.83 4.35a.73.73 0 00-.73.73v5.09c0 .4.32.72.72.72h5.1a.73.73 0 00.73-.72V9.44a.73.73 0 00-.73-.73h-5.1Z"/>
  </svg>
);

const SquarespaceIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <path d="M22.655 8.719c-1.802-1.801-4.726-1.801-6.564 0l-7.351 7.35c-.45.45-.45 1.2 0 1.65.45.449 1.2.449 1.65 0l7.351-7.351c.899-.899 2.362-.899 3.264 0 .9.9.9 2.364 0 3.264l-7.239 7.239c.9.899 2.362.899 3.263 0l5.589-5.589c1.836-1.838 1.836-4.763.037-6.563zm-2.475 2.437c-.451-.45-1.201-.45-1.65 0l-7.354 7.389c-.9.899-2.361.899-3.262 0-.45-.45-1.2-.45-1.65 0s-.45 1.2 0 1.649c1.801 1.801 4.726 1.801 6.564 0l7.351-7.35c.449-.487.449-1.239.001-1.688zm-2.439-7.35c-1.801-1.801-4.726-1.801-6.564 0l-7.351 7.351c-.45.449-.45 1.199 0 1.649s1.2.45 1.65 0l7.395-7.351c.9-.899 2.371-.899 3.27 0 .451.45 1.201.45 1.65 0 .421-.487.421-1.199-.029-1.649h-.021zm-2.475 2.437c-.45-.45-1.2-.45-1.65 0l-7.351 7.389c-.899.9-2.363.9-3.265 0-.9-.899-.9-2.363 0-3.264l7.239-7.239c-.9-.9-2.362-.9-3.263 0L1.35 8.719c-1.8 1.8-1.8 4.725 0 6.563 1.801 1.801 4.725 1.801 6.564 0l7.35-7.351c.451-.488.451-1.238 0-1.688h.002z"/>
  </svg>
);

const OtherIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <circle cx="5" cy="12" r="2.5"/>
    <circle cx="12" cy="12" r="2.5"/>
    <circle cx="19" cy="12" r="2.5"/>
  </svg>
);

const platforms = [
  { id: "woocommerce", label: "WooCommerce", icon: WooCommerceIcon },
  { id: "shopify", label: "Shopify", icon: ShopifyIcon },
  { id: "bigcommerce", label: "BigCommerce", icon: BigCommerceIcon },
  { id: "wix", label: "Wix", icon: WixIcon },
  { id: "square", label: "Square Online", icon: SquareIcon },
  { id: "squarespace", label: "Squarespace", icon: SquarespaceIcon },
  { id: "other", label: "Other", icon: OtherIcon },
];

export default function Signup({ onAuthenticated, onSwitchToLogin }) {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [companyName, setCompanyName] = useState("");
  const [platform, setPlatform] = useState("");
  const [agreedToTerms, setAgreedToTerms] = useState(true);
  const [agreedToUpdates, setAgreedToUpdates] = useState(true);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!platform) {
      setError("Please select your store platform");
      return;
    }
    if (!agreedToTerms) {
      setError("You must agree to the Terms of Service and Privacy Policy to continue");
      return;
    }
    setError("");
    setLoading(true);
    try {
      // XHR adapter bypasses PostHog's `fetch` monkey-patch on production
      // which consumes the response body and throws "body stream already
      // read". See Login.jsx for the full root-cause note.
      const res = await axios.post(
        `${API_URL}/api/auth/signup`,
        {
          email,
          password,
          company_name: companyName,
          platform,
          agreed_to_terms: agreedToTerms,
          agreed_to_updates: agreedToUpdates,
        },
        { adapter: "xhr", headers: { "Content-Type": "application/json" } }
      );
      const data = res.data || {};
      if (data.token) {
        localStorage.setItem("id_token", data.token);
        localStorage.setItem("id_user", JSON.stringify(data.user));

        // Meta Pixel: fire CompleteRegistration the moment we get the
        // user back. The backend already fired the same event with a
        // deterministic event_id (completeregistration_<user_id>) — we
        // pass that here so Meta dedupes the two.
        try {
          const { trackEvent } = await import("../lib/metaPixel");
          trackEvent(
            "CompleteRegistration",
            { content_name: "trial_signup", status: "success", platform },
            { deterministicId: `completeregistration_${data.user?.id}` },
          );
          // Also fire Lead — many ad accounts optimize for Lead before
          // CompleteRegistration shows enough volume.
          trackEvent("Lead", { content_name: "Signup Form" });
        } catch {}

        // Force a fresh signup to land on the Dashboard regardless of
        // which page the user was viewing when they hit "Sign up". Without
        // this, the URL stays at whatever path was open (e.g. /signup, /pricing,
        // or a deep-link), and WooCommerce signups in particular miss the
        // Dashboard's "download your plugin zip" callout — which is the
        // single most important next step for them.
        if (window.location.pathname !== "/") {
          window.history.replaceState({}, "", "/");
        }
        onAuthenticated(data.user);
      } else {
        setError("Signup failed. Please try again.");
      }
    } catch (err) {
      const detail = err?.response?.data?.detail;
      if (typeof detail === "string") {
        setError(detail);
      } else if (err?.response) {
        setError("Signup failed. Please try again.");
      } else {
        setError("Connection failed. Please try again.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0A0A0A] flex items-center justify-center py-8" data-testid="signup-page">
      <div className="w-full max-w-sm">
        <div className="flex items-center justify-center gap-3 mb-8">
          <div className="w-12 h-12 bg-[#9FFF00] flex items-center justify-center">
            <span className="text-black font-black text-base">ID</span>
          </div>
          <h1 className="text-2xl font-black tracking-tight text-white">
            INFLUENCE<span className="text-[#9FFF00]">DETECTOR</span>
          </h1>
        </div>

        <div className="bg-[#9FFF00]/10 border border-[#9FFF00]/20 p-3 mb-6 text-center">
          <p className="text-[#9FFF00] text-sm font-bold uppercase tracking-wider">7-Day Free Trial</p>
          <p className="text-white/50 text-xs mt-1">500 orders included. No credit card required.</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <input
            type="text"
            value={companyName}
            onChange={(e) => setCompanyName(e.target.value)}
            placeholder="Company / Store name"
            className="w-full px-4 py-3 bg-white/5 border border-white/10 text-white placeholder-white/30 focus:outline-none focus:border-[#9FFF00] transition-colors"
            autoFocus
            data-testid="signup-company-input"
          />
          <input
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            placeholder="Email address"
            className="w-full px-4 py-3 bg-white/5 border border-white/10 text-white placeholder-white/30 focus:outline-none focus:border-[#9FFF00] transition-colors"
            data-testid="signup-email-input"
          />
          <input
            type="password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            placeholder="Password (min 6 characters)"
            className="w-full px-4 py-3 bg-white/5 border border-white/10 text-white placeholder-white/30 focus:outline-none focus:border-[#9FFF00] transition-colors"
            data-testid="signup-password-input"
          />

          <div>
            <p className="text-white/50 text-xs uppercase tracking-wider font-bold mb-2">Your store platform</p>
            <div className="grid grid-cols-3 gap-2">
              {platforms.map((p) => (
                <button
                  key={p.id}
                  type="button"
                  onClick={() => setPlatform(p.id)}
                  className={`flex flex-col items-center justify-center gap-1.5 py-3 px-2 border transition-all ${
                    platform === p.id
                      ? "border-[#9FFF00] bg-[#9FFF00]/10 text-white"
                      : "border-white/10 bg-white/5 text-white/40 hover:border-white/20 hover:text-white/60"
                  }`}
                  data-testid={`platform-${p.id}`}
                >
                  <p.icon />
                  <span className="text-[11px] font-bold">{p.label}</span>
                </button>
              ))}
            </div>
          </div>

          <div className="space-y-2.5 pt-1">
            <label className="flex items-start gap-2.5 cursor-pointer group" data-testid="agree-terms-row">
              <input
                type="checkbox"
                checked={agreedToTerms}
                onChange={(e) => setAgreedToTerms(e.target.checked)}
                required
                className="mt-0.5 w-4 h-4 accent-[#9FFF00] cursor-pointer flex-shrink-0"
                data-testid="agree-terms-checkbox"
              />
              <span className="text-sm text-white/70 leading-snug group-hover:text-white/90 transition-colors">
                I agree to the{" "}
                <a href="https://influencedetector.com/terms" target="_blank" rel="noopener noreferrer" className="text-[#9FFF00] hover:underline font-medium">Terms of Service</a>
                {" "}and{" "}
                <a href="https://influencedetector.com/privacy" target="_blank" rel="noopener noreferrer" className="text-[#9FFF00] hover:underline font-medium">Privacy Policy</a>
                <span className="text-red-400 ml-1">*</span>
              </span>
            </label>
            <label className="flex items-start gap-2.5 cursor-pointer group" data-testid="agree-updates-row">
              <input
                type="checkbox"
                checked={agreedToUpdates}
                onChange={(e) => setAgreedToUpdates(e.target.checked)}
                className="mt-0.5 w-4 h-4 accent-[#9FFF00] cursor-pointer flex-shrink-0"
                data-testid="agree-updates-checkbox"
              />
              <span className="text-sm text-white/70 leading-snug group-hover:text-white/90 transition-colors">
                I agree to receive important account and platform updates
              </span>
            </label>
          </div>

          {error && (
            <p className="text-red-400 text-sm" data-testid="signup-error">{error}</p>
          )}

          <button
            type="submit"
            disabled={loading || !email || !password || !companyName || !agreedToTerms}
            className="w-full py-3 bg-[#9FFF00] text-black font-bold uppercase tracking-wider hover:bg-[#8AE600] disabled:opacity-50 transition-colors"
            data-testid="signup-submit-button"
          >
            {loading ? "Creating account..." : "Start Free Trial"}
          </button>
        </form>

        <p className="text-white/40 text-sm text-center mt-6">
          Already have an account?{" "}
          <button
            onClick={onSwitchToLogin}
            className="text-[#9FFF00] hover:underline font-medium"
            data-testid="switch-to-login"
          >
            Sign in
          </button>
        </p>
      </div>
    </div>
  );
}
